import moment from "moment/moment"
import {
    FormState,
    ResetFormStateProps,
    SubGroupSelectInfo,
} from "./TestTakerSearchTypes"
import {ProductId} from "../../../../../types/types"
import {GroupTypeLookup} from "../../../../../util/Constants"

/** Removes all filters, including date filters. */
export function getResetFormState({
                                      rootGroupId,
                                      rootSubGroupOptions,
                                      rootLanguageOptions,
                                      rootProductOptions,
                                      rootSubGroupHeader,
                                      rootParticipationCodes,
                                      mode
                                  }: ResetFormStateProps) {
    const cleanFormState: FormState = {
        subGroupHeader: rootSubGroupHeader,
        subGroupOptions: rootSubGroupOptions,
        languageOptions: rootLanguageOptions,
        productOptions: rootProductOptions,
        participationCodes: rootParticipationCodes,
        selectedSubGroup: rootGroupId,
        selectedLanguage: -1,
        selectedParticipationCode: undefined,
        productId: -1,
        testCode: "",
        firstName: "",
        lastName: "",
        loginName: "",
        startDate: mode === "reset" ? beginTestingYear() : null,
        endDate: mode === "reset" ? moment() : null
    }
    return cleanFormState
}

/** Individual Reports are deeply coupled to specific products. We need to filter for products that are actually printable.*/
export function isPrintSupportedProduct(productId: number) {
    return [ProductId.STAMP4SE, ProductId.STAMP4S, ProductId.STAMP_SIGN_LANGUAGE, ProductId.STAMP_CEFR, ProductId.APT].includes(productId)
}

export function beginTestingYear() {
    return moment().subtract(1, 'year').month(7).date(1)
}

/** This function allows us to easily include a header detailing child types in a select dropdown.
 *
 *  Note: This function expects that only direct child groups are fetched, not ancestors.
 *  If ancestors are fetched they should be fed to this function one layer at a time. */
export function getSubGroupHeader(subGroupsInfo: SubGroupSelectInfo[]): FormState["subGroupHeader"] {

    const distinctGroupTypes = new Set(subGroupsInfo.map(subGroup => subGroup.groupType)).size

    /** There are no child groups to select for this user
     *  This is expected for Class reports who have no children */
    if (distinctGroupTypes === 0) {
        return undefined
    }
    if (distinctGroupTypes > 1) {
        console.error("Multiple distinct subgroup types found for this user")
        return undefined
    }

    return GroupTypeLookup[subGroupsInfo[0].groupType]
}